var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamsIconV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8087_2746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1594 6.11314H15.2911C15.6815 6.11314 15.9979 6.42962 15.9979 6.81995V10.5833C15.9979 12.0179 14.8349 13.181 13.4003 13.181H13.388C11.9534 13.1812 10.7902 12.0184 10.79 10.5837V6.4826C10.79 6.43408 10.7996 6.38603 10.8181 6.3412C10.8367 6.29637 10.8639 6.25563 10.8982 6.22132C10.9325 6.18701 10.9732 6.1598 11.018 6.14124C11.0629 6.12267 11.1109 6.11313 11.1594 6.11314Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9518 5.36923C14.8763 5.36923 15.6258 4.61977 15.6258 3.69526C15.6258 2.77075 14.8763 2.02129 13.9518 2.02129C13.0273 2.02129 12.2778 2.77075 12.2778 3.69526C12.2778 4.61977 13.0273 5.36923 13.9518 5.36923Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74412 5.36924C10.0795 5.36924 11.1621 4.28669 11.1621 2.95129C11.1621 1.61589 10.0795 0.53334 8.74412 0.53334C7.40873 0.53334 6.32617 1.61589 6.32617 2.95129C6.32617 4.28669 7.40873 5.36924 8.74412 5.36924Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9679 6.11314H5.14787C4.76217 6.1227 4.45707 6.4428 4.466 6.82851V11.1209C4.41214 13.4355 6.24332 15.3563 8.55786 15.4129C10.8724 15.3563 12.7036 13.4355 12.6498 11.1209V6.82851C12.6587 6.4428 12.3536 6.1227 11.9679 6.11314Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.92995 6.11314V12.1282C8.92906 12.2631 8.88834 12.3948 8.81289 12.5066C8.73744 12.6185 8.63064 12.7055 8.50588 12.7569C8.42466 12.7913 8.33737 12.809 8.24921 12.809H4.79336C4.745 12.6862 4.70038 12.5634 4.66314 12.437C4.53293 12.0101 4.4665 11.5664 4.46601 11.1201V6.82738C4.45708 6.4423 4.76168 6.1227 5.14676 6.11321L8.92995 6.11314Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.55781 6.11314V12.5002C8.55781 12.5884 8.54013 12.6757 8.50576 12.7569C8.45439 12.8817 8.36732 12.9885 8.25547 13.0639C8.14362 13.1394 8.01197 13.1801 7.87706 13.181H4.96818C4.90495 13.0582 4.84541 12.9354 4.79336 12.809C4.74335 12.6874 4.69989 12.5632 4.66314 12.437C4.53293 12.0101 4.4665 11.5664 4.46601 11.1201V6.82738C4.45708 6.4423 4.76168 6.1227 5.14676 6.11321L8.55781 6.11314Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.55787 6.11314V11.7563C8.55506 12.131 8.25196 12.4342 7.87712 12.437H4.66314C4.53293 12.0101 4.4665 11.5664 4.46601 11.1201V6.82738C4.45708 6.4423 4.76168 6.1227 5.14676 6.11321L8.55787 6.11314Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.18591 6.11314V11.7563C8.18304 12.131 7.87993 12.4342 7.50516 12.437H4.66314C4.53293 12.0101 4.4665 11.5664 4.46601 11.1201V6.82738C4.45708 6.4423 4.76168 6.1227 5.14676 6.11321L8.18591 6.11314Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.93005 4.18999V5.36173C8.86681 5.36548 8.80727 5.36923 8.74404 5.36923C8.6808 5.36923 8.62126 5.36548 8.55802 5.36173C8.43247 5.3534 8.30796 5.33349 8.18607 5.30225C7.81471 5.21429 7.46944 5.03969 7.17849 4.79272C6.88755 4.54575 6.65919 4.23342 6.5121 3.88127C6.46074 3.76131 6.42088 3.63674 6.39307 3.50925H8.2493C8.62463 3.51068 8.92861 3.8146 8.93005 4.18999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.55807 4.56196V5.36173C8.43252 5.3534 8.30801 5.33349 8.18612 5.30225C7.81477 5.21429 7.46951 5.03968 7.17858 4.79271C6.88764 4.54574 6.6593 4.23341 6.51221 3.88127H7.87733C8.25272 3.88265 8.55664 4.18662 8.55807 4.56196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.55807 4.56196V5.36173C8.43252 5.3534 8.30801 5.33349 8.18612 5.30225C7.81477 5.21429 7.46951 5.03968 7.17858 4.79271C6.88764 4.54574 6.6593 4.23341 6.51221 3.88127H7.87733C8.25272 3.88265 8.55664 4.18662 8.55807 4.56196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.18618 4.56196V5.30225C7.81481 5.21429 7.46954 5.03968 7.17859 4.7927C6.88765 4.54571 6.65929 4.23337 6.51221 3.88121H7.50543C7.88083 3.88265 8.18474 4.18662 8.18618 4.56196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.684314 3.88121H7.50429C7.88093 3.88121 8.18622 4.1865 8.18622 4.56308V11.3831C8.18622 11.7597 7.88093 12.065 7.50435 12.065H0.684314C0.307731 12.065 0.00244141 11.7597 0.00244141 11.3831V4.56315C0.00244141 4.18644 0.307731 3.88121 0.684314 3.88121Z",
    fill: "url(#paint0_linear_8087_2746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88874 6.47698H4.52537V10.1894H3.6568V6.47698H2.2998V5.75681H5.88874V6.47698Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8087_2746",
    x1: 142.171,
    y1: -49.3957,
    x2: 676.218,
    y2: 875.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8087_2746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsIconV2);
export default __webpack_public_path__ + "static/media/teams_icon_v2.f59a58d5831453121598f8fc4a0f749c.svg";
export { ForwardRef as ReactComponent };